import React from "react";
import DLSLoader from "../../../dls/dls-loader";
import { IDSSLoader } from "../../DSSFramework";

const DSSLoader = ({ label, id = "loader" }: IDSSLoader) =>
{
    return (
        <DLSLoader label={ label } id={ id } />
    );
};
export default DSSLoader;